import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table } from 'react-bootstrap';
import Button from '../Button';
import Callout from '../Callout';
import { useNavigate } from 'react-router-dom';

function ParentApplicationsSection() {
  const [parentApplication, setParentApplication] = useState(null);
  const [hasPaymentsDue, setHasPaymentsDue] = useState(false);
  const [hasMonthlyPayments, setHasMonthlyPayments] = useState(false);
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch parent's own application
    const fetchParentApplication = async () => {
      try {
        const response = await axios.get(`${API_ENDPOINT}/api/application/`, {
          headers: { Authorization: `Token ${localStorage.getItem('token')}` },
        });
        if (response.data && response.data.id) {
          setParentApplication({
            id: response.data.id,
            status: response.data.application_status,
            name: (() => {
              const cachedUser = JSON.parse(localStorage.getItem('cachedUser'));
              return cachedUser ? `${cachedUser.first_name} ${cachedUser.last_name}` : 'N/A';
            })(),
          });
        }
      } catch (error) {
        setParentApplication(null);
      }
    };

    // Check for payments due (simplified - you can enhance this logic)
    const checkPaymentsDue = async () => {
      try {
        const token = localStorage.getItem('token');
        const config = { headers: { Authorization: `Token ${token}` } };
        
        const response = await axios.get(`${API_ENDPOINT}/api/payments-due/`, config);
        const payments = response.data;
        setHasPaymentsDue(payments.length > 0);
        
        // Check if user has monthly payments set up
        const hasMonthly = payments.some(payment => payment.payment_type === 'monthly');
        setHasMonthlyPayments(hasMonthly);
      } catch (error) {
        console.error('Error checking payments due:', error);
        // Default to false if there's an error
        setHasPaymentsDue(false);
        setHasMonthlyPayments(false);
      }
    };

    fetchParentApplication();
    checkPaymentsDue();
  }, [API_ENDPOINT, parentApplication && parentApplication.status]);

  const styles = {
    container: {
      width: '100%',
      backgroundColor: '#FFFFFF',
      padding: '20px',
      marginBottom: '20px',
      textAlign: 'left',
    },
    tableContainer: { width: '100%' },
  };

  const getStatusMessage = (status) => {
    switch (status) {
      case 'complete':
        return 'Your application has been submitted for review and you will receive a email notification regarding your acceptance within 2-3 of submitting.';
      case 'enrolled':
        return 'Your student is successfully enrolled in Dual School!';
      default:
        return status || 'N/A';
    }
  };

  const getActionButton = (status) => {
    switch (status) {
      case 'accepted':
        return (
          <Button
            variant="primary"
            onClick={() => navigate('/enrollment-contract')}
          >
            Sign Enrollment Contract
          </Button>
        );
      case 'enrolled':
        if (hasMonthlyPayments) {
          return (
            <span style={{ 
              color: '#6c757d', 
              fontSize: '0.9em'
            }}>
              No Action Required
            </span>
          );
        } else if (hasPaymentsDue) {
          return (
            <Button
              variant="primary"
              onClick={() => navigate('/parent-payments')}
            >
              Make Tuition Payment
            </Button>
          );
        } else {
          return (
            <span style={{ 
              color: '#6c757d', 
              fontSize: '0.9em'
            }}>
              No Action Required
            </span>
          );
        }
      default:
        return (
          <Button
            onClick={() => {
              navigate('/application-summary');
            }}
          >
            View Application
          </Button>
        );
    }
  };

  return (
    <div className="page-container">
      <div style={styles.container}>
        <h1>Applications</h1>
        {/* <Button
          variant="primary"
          onClick={() => navigate('/application')}
        >
          New Student Application
        </Button> */}
        <Callout text={`You can view your application and status below.`} />
        {parentApplication && parentApplication.status === 'accepted' && (
          <div style={{ marginBottom: 16 }}>
            <div className="alert alert-warning" style={{ background: '#fff3cd', color: '#856404', border: '1px solid #ffeeba', borderRadius: 4, padding: 12 }}>
              <strong>Action Required:</strong> Please sign the enrollment contract to officially enroll your student for the 2025-26 school year.
            </div>
          </div>
        )}
        {parentApplication && parentApplication.status === 'enrolled' && hasPaymentsDue && !hasMonthlyPayments && (
          <div style={{ marginBottom: 16 }}>
            <div className="alert alert-warning" style={{ background: '#fff3cd', color: '#856404', border: '1px solid #ffeeba', borderRadius: 4, padding: 12 }}>
              <strong>Action Required:</strong> Please make your tuition payment to before the start of the 2025-26 school year.
            </div>
          </div>
        )}
        {parentApplication && (
          <div style={styles.tableContainer}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Name</th>
                  <th style={{ maxWidth: 260, whiteSpace: 'normal', wordBreak: 'break-word' }}>Application Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{parentApplication.name}</td>
                  <td style={{ maxWidth: 260, whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {getStatusMessage(parentApplication.status)}
                  </td>
                  <td>
                    {getActionButton(parentApplication.status)}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        )}
      </div>
    </div>
  );
}

export default ParentApplicationsSection; 